import { MailOutlined, PhoneOutlined } from '@ant-design/icons'
import './App.css'
import { Col, Layout, Row, Space } from 'antd'
import { Footer } from 'antd/es/layout/layout'
import Menu from './components/menu'
import locales from './locales/locale'
import { useState } from 'react'
import Home from './Home'
import { Route, Routes } from 'react-router-dom'
import Elettronica from './Elettronica'
import Analcolici from './Analcolici'

function App() {
  const [language, setLanguage] = useState(locales.getLanguage())

  return (
    <Layout>
      <Menu setLang={setLanguage} lang={language} />
      <Routes>
        <Route path="/" element={<Home lang={language} />} />
        <Route path="/analcolici" element={<Analcolici lang={language} />} />
        <Route path="/elettronica" element={<Elettronica lang={language} />} />
      </Routes>
      <Footer>
        <Row style={{ placeContent: 'center' }}>
          <Col>
            <b>{locales.contact}</b>
          </Col>
        </Row>
        <Row style={{ placeContent: 'center' }}>
          <Col>
            <Space
              style={{
                borderRight: '1px #ffffff3d solid',
                padding: '0 1vw',
              }}
              size={'small'}
            >
              <PhoneOutlined />
              <a href="tel:+420606082404" style={{ color: 'white' }}>
                +420 606082404
              </a>
            </Space>
          </Col>
          <Col>
            <Space
              style={{
                padding: '0 1vw',
              }}
              size={'small'}
            >
              <MailOutlined />
              <a href="mailto:info@zefiroint.com" style={{ color: 'white' }}>
                info@zefiroint.com
              </a>
            </Space>
          </Col>
        </Row>
        <Row style={{ placeContent: 'center', marginTop: '1vw' }}>
          <Col
            style={{
              padding: '0 1vw',
            }}
          >
            <a
              style={{ color: 'white', fontWeight: 'bold' }}
              target="_blank"
              href="https://www.termsfeed.com/live/d1da41b7-bf3c-4590-9deb-6ecabda60065"
              rel="noreferrer"
            >
              Privacy policy
            </a>
          </Col>
          <Col
            style={{
              padding: '0 1vw',
            }}
          >
            <a
              style={{ color: 'white', fontWeight: 'bold' }}
              target="_blank"
              href="https://www.cookiepolicygenerator.com/live.php?token=wrobUMqgvr0mLDUYUjGVUXgIuDVdHyCM"
              rel="noreferrer"
            >
              Cookie policy
            </a>
          </Col>
        </Row>
      </Footer>
    </Layout>
  )
}

export default App
